import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'
import Icon from 'components/Icon'
import Tag from 'components/Tag'
import Typography from 'components/Typography'

import classes from './Free.module.scss'

/** @type {import("./types").default} */
const Free = ({ hasFreeTrial = false, ...props }) => (
  <Grid className={clsx('Free', classes.root)} {...props}>
    <Typography component="span" className={classes.free}>
      Free
    </Typography>

    <Tag className={classes.tag} size="tiny" color={hasFreeTrial ? 'teal' : 'grey'} disableRipple>
      Free trial
      <Icon icon={hasFreeTrial ? 'check' : 'times'} size="12" />
    </Tag>
  </Grid>
)

export default Free
